import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const EngineConfigCard = ({ config, onEdit, onDelete, onUse }) => {
  const { t } = useTranslation("common");

  return (
    <div className="engine-card">
      <div className="engine-card-header">
        <div className="engine-badge">
          <div className="eng-name">{config.type}</div>
          <div className="eng-ver">{config.version}</div>
        </div>
        <div>
          <div className="engine-card-title">{config.name}</div>
          <span className="connected-badge">● {t("Connected")}</span>
        </div>
      </div>
      <div className="engine-card-body">
        <div className="engine-field">
          <span className="field-label">{t("Name:")}</span>
          <span className="field-value">{config.name}</span>
        </div>
        <div className="engine-field">
          <span className="field-label">{t("Username:")}</span>
          <span className="field-value">{config.username}</span>
        </div>
        <div className="engine-field">
          <span className="field-label">{t("Database:")}</span>
          <span className="field-value">{config.database}</span>
        </div>
        <div className="engine-field">
          <span className="field-label">{t("URL:")}</span>
          <span className="field-value">
            <a href={config.url} target="_blank" rel="noreferrer">
              {config.url}
            </a>
          </span>
        </div>
      </div>
      <div className="engine-card-footer">
        <button type="button" className="btn btn-ghost btn-sm" onClick={() => onEdit(config)}>
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
          </svg>
          <span>{t("Edit")}</span>
        </button>
        <button type="button" className="btn btn-danger btn-sm" onClick={() => onDelete(config)}>
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="3 6 5 6 21 6" />
            <path d="M19 6l-1 14H6L5 6" />
            <path d="M9 6V4h6v2" />
          </svg>
          <span>{t("Delete")}</span>
        </button>
        <button type="button" className="btn btn-ghost btn-sm btn-use" onClick={() => onUse(config)}>
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="9 18 15 12 9 6" />
          </svg>
          <span>{t("Use")}</span>
        </button>
      </div>
    </div>
  );
};

EngineConfigCard.propTypes = {
  config: PropTypes.shape({
    id: PropTypes.string,
    type: PropTypes.string,
    version: PropTypes.string,
    name: PropTypes.string,
    username: PropTypes.string,
    database: PropTypes.string,
    url: PropTypes.string
  }).isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onUse: PropTypes.func.isRequired
};

export default EngineConfigCard;
